module.exports = __webpack_public_path__ + "img/guillermo-molini.32226faa.jpg";